import React, { useState, useEffect} from 'react';
import CardItem from "./CardItem";



function Featured(){

    const [listings, setListings] = useState()

        useEffect(() => {
         fetch("/api/featured")
            .then((response) => {
            if (!response.ok) {
                throw new Error(`Request failed: ${response.status}`);
            }

            return response.json();
            })
            .then((data) => {
            setListings(data);
            })
            .catch((err) => {
            console.error("Could not load featured listings:", err);
            });
        }, []);

    return (
        <div className='featured'>
            <h1>Featured Homes</h1>
            <div className='featuredHomes'>
                {listings?.houseListings?.slice(0, 4).map((listing) => {
                    const image =
                        listing.Media?.[0]?.LocalMediaURL ??
                        listing.Media?.[0]?.MediaURL ??
                        listing.Media?.[0] ??
                        "/placeholder-house.jpg";

                    return (
                        <CardItem
                        key={listing.ListingKey}
                        src={image}
                        address={listing.UnparsedAddress}
                        price={listing.ListPrice}
                        bed={listing.BedroomsTotal}
                        bath={listing.BathroomsTotalInteger}
                        sqft={listing.LotSizeSquareFeet}
                        listingKey={listing.ListingKey}
                        PropertyType={listing.PropertyType}
                        county={listing.CountyOrParish}
                        />
                    );
                })}
            </div>
            <h1>Featured Land</h1>
            <div className='featuredHomes'>
                {listings?.landListings?.slice(0, 4).map((listing) => {
                    const image =
                        listing.Media?.[0]?.LocalMediaURL ??
                        listing.Media?.[0]?.MediaURL ??
                        listing.Media?.[0] ??
                        "/placeholder-house.jpg";

                    return (
                        <CardItem
                        key={listing.ListingKey}
                        src={image}
                        address={listing.UnparsedAddress}
                        price={listing.ListPrice}
                        bed={listing.BedroomsTotal}
                        bath={listing.BathroomsTotalInteger}
                        sqft={listing.LotSizeSquareFeet}
                        listingKey={listing.ListingKey}
                        PropertyType={listing.PropertyType}
                        county={listing.CountyOrParish}
                        />
                    );
                    })}
            </div>
        </div>
    );

}

export default Featured;
